'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import Chapter from 'academy-shared-js/records/Chapter';
import Video from 'academy-shared-js/records/Video';
import { getDurationForContentList } from '../../utils/ContentUtils';
import { getHumanizedDuration } from '../../utils/utils';
import styled from '../../utils/Styling';
const Duration = styled.span.withConfig({
  displayName: "LessonDuration__Duration",
  componentId: "sc-1udjs8i-0"
})(["font-weight:500;"]);

const LessonDuration = ({
  contentList
}) => {
  const totalDurationInSeconds = getDurationForContentList(contentList);
  const totalDurationFormatted = getHumanizedDuration(totalDurationInSeconds);
  const videos = contentList.count(thisContent => thisContent instanceof Video);
  const chapters = contentList.count(thisContent => thisContent instanceof Chapter);
  return /*#__PURE__*/_jsxs(Duration, {
    children: [videos > 0 && /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.video",
        options: {
          count: videos
        }
      }), ' | ']
    }), chapters > 0 && /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.chapter",
        options: {
          count: chapters
        }
      }), ' | ']
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.lessonNavigator.info",
      options: {
        totalDuration: totalDurationFormatted
      }
    })]
  });
};

LessonDuration.propTypes = {
  contentList: ImmutablePropTypes.list.isRequired
};
export default LessonDuration;